export const LABEL_STYLE = {
    fontSize: '16px',
    color: '#344E5C',
    textAnchor: 'middle'
};

export const colorRanges = ['#F47B33', '#5969c0', '#E85A68', '#BB558A', '#7D5892', '#45557D', '#2F4858', '#FD73A2', '#FFC565', '#d5d5d5'];
export const config = {
    header: { //Targert the time header containing the information month/day of the week, day and time.
        top: {//Tartget the month elements
            style: { backgroundColor: 'white', color: '#6F767D' } //The style applied to the month elements
        },
        middle: {//Tartget elements displaying the day of week info
            style: { backgroundColor: 'white', color: '#6F767D' }, //The style applied to the day of week elements
            selectedStyle: { backgroundColor: '#b13525' }//The style applied to the day of week elements when is selected
        },
        bottom: {//Tartget elements displaying the day number or time 
            style: { backgroundColor: 'white', color: 'white', fontSize: 9 },//the style tp be applied 
            selectedStyle: { backgroundColor: 'white', fontWeight: 'bold' }//the style tp be applied  when selected
        }
    },
    taskList: {//the right side task list
        title: {//The title od the task list
            label: 'Eventos',//The caption to display as title
            style: {
                backgroundColor: '#F0F2F4', borderBottom: 'solid 1px silver',
                color: '#344E5C', textAlign: 'center', fontWeight: 'bold'
            }//The style to be applied to the title
        },
        task: {// The items inside the list diplaying the task
            style: { backgroundColor: '#F0F2F4', color: '#344E5C' }// the style to be applied
        },
        verticalSeparator: {//the vertical seperator use to resize he width of the task list
            style: { backgroundColor: 'white', },//the style
            grip: {//the four square grip inside the vertical separator
                style: { backgroundColor: '#cfcfcd' }//the style to be applied
            }
        }
    },
    dataViewPort: {//The are where we display the task
        rows: {//the row constainting a task
            style: { backgroundColor: 'white', borderBottom: 'solid 0.5px #cfcfcd', height: '30px' }
        },
        task: {
            showLabel: false,//If the task display the a lable
            style: {
                position: 'absolute', borderRadius: 14, color: 'white',
                textAlign: 'center', backgroundColor: 'grey',

            },
            selectedStyle: {}//the style tp be applied  when selected
        }
    },
    links: {//The link between two task
        color: 'black',
        selectedColor: '#ff00fa'
    }
};